module.exports = {"421002001":"中山街道","421002002":"崇文街道","421002003":"解放街道","421002004":"胜利街道","421002005":"朝阳街道","421002100":"锣场镇","421002101":"岑河镇","421002102":"观音当镇","421002103":"关沮镇","421002200":"立新乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421002.json
// module id = 1613
// module chunks = 0